import { Component, OnInit } from '@angular/core';
import { EditStudentService } from '../edit-student.service';
import { LoginUserService } from '../../../core/services/login-user.service';
import { MessageService } from '../../../core/services/message.service';
@Component({
  selector: 'app-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.scss']
})
export class UserPasswordComponent implements OnInit {

  constructor(
    private _eidtStuService: EditStudentService,
    private _login: LoginUserService,
    private _msg: MessageService
  ) { }

  ngOnInit() {
  }
  formData: any = {};

  //发送用户密码
  password() {
    let obj = {
      oldpwd: this.formData['usedPass'],
      newpwdone: this.formData['newPass'],
      newpwdtwo: this.formData['reNewPass']
    }
    this._eidtStuService.postPassWordData(obj).then(resp => {
      if (resp.success) {
        if (resp['data']) {
          this._msg.success('密码修改成功');
        } else {
          this._msg.warn(resp['msg']);
        }
      }
    })

  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/user-password/user-password.component.ts